import React, { useContext, useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback } from "react";

import { BoardContext, CardContext, SlotMachineContext, SocketContext, TeamContext, UserContext } from "../../../context";
import whiteArrow from "../../../assets/icons/white_arrow.svg";

import { FrontSide, MainButton } from "../../atoms";
import { ICard } from "../../../interfaces";
import { useWindowDimensions, useSound } from "../../../hooks";
import { CardType } from "../../../util/enums";
import PdfIndex from "../../molecules/Statistics/Pdf/PdfIndex";
import axios from "axios";

export interface SlotMachineRefObject {
    dropedStrenghtCard(): void;
}

const SlotMachineChosenCardHolder = forwardRef((_props: {}, ref: React.Ref<SlotMachineRefObject>) => {
    useImperativeHandle(ref, () => ({ dropedStrenghtCard }));

    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { draggableCard, isStrengthCardCurrentlyDragged, setIsStrengthCardCurrentlyDragged } = useContext(CardContext);
    const { userData } = useContext(UserContext);
    const { 
        setShowIt, 
        confirmSelectionDisabled,
        setConfirmSelectionDisabled,
        setLastDroppedCard, 
        allStrengthCardsIdsState, 
        isConfirmSelectionClicked, 
        verticalCardIndexOfSelectedRow, 
        verticalCardIdsAndTheirIndexes,
        setAddStrengthCardDemo,
        setShowMidGameWaitingWindow
    } = useContext(SlotMachineContext);
    const { didUserRejoinTheGame, setDidUserRejoinTheGame } = useContext(BoardContext);
    const [ready, setReady] = useState(false);
    const [chosenStrengthCard, setChosenStrengthCard] = useState<(ICard | undefined)[]>(new Array(5));
    const { width } = useWindowDimensions();
    const alertRef = useRef<NodeJS.Timeout>();
    const [selectedIndex, setSelectedIndex] = useState<(number | null)>(null);
    const [isArrowShown, setIsArrowShown] = useState<boolean>(true);
    const {playSound} = useSound();
    const demoCard: ICard = {
        type: CardType.STRENGTH,
        description: "0",
        id: 1111,
    }
    const downloadText = "Download";
    const confirmText = "Confirm";
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
    const pathname : string | undefined = window.location.pathname;
    const isPageSlotMachineDemoRendered : boolean = pathname.includes("/slotmachineDemo");

    let phase: any;
    const myEmail = localStorage["userEmailInCaseHeLogsOut"];

    let payload = {
		matchId: urlTokenExtracted,
		gameId: 1,
		email: myEmail,
	}
    
    axios({
        method: "get",
        url: process.env.REACT_APP_BACKEND_URL + `api/matches/phase/${urlTokenExtracted}`,
    })
    .then((res: any) => {
        handleMidGameJoining(res);
    })
    .catch((err: any) => console.error(err));

    const handleMidGameJoining = (res: any) => {
        phase = res?.data?.phase
        if(phase === 4 && ready) {
            socket?.emit("joinGame",payload)
            window.location.href = process.env.REACT_APP_FRONTEND_URL + "board/" + urlTokenExtracted;
            return;
        }
    }

    useEffect(() => {
        if (!userData || !game) return;

        let userNicknameInLobby = game?.inGameLobby?.filter((lobby: any) => lobby?.email == myEmail)[0].nickname;
        let userInLobbyForStrengthCards = game?.gameInfo?.inGameLobby.filter((user: any) => user.nickName === userNicknameInLobby)[0].currentStrengthCards;
        let currentStrengthCardsFromGameObject = userInLobbyForStrengthCards ? userInLobbyForStrengthCards : [];

        const numberOfSelectedStrengthCardsFromSlotMachine = currentStrengthCardsFromGameObject.length;
        
        let mappedArryOfStrengthCardsObjectsFittedForFrontend = currentStrengthCardsFromGameObject.map((strengthCardFromBackEnd: any) => {
            return convertRecievedObjectToStrengthCardObject(strengthCardFromBackEnd);
        })

        if(numberOfSelectedStrengthCardsFromSlotMachine === 1) {
            setDidUserRejoinTheGame(false);
        }

        if (numberOfSelectedStrengthCardsFromSlotMachine != 1 && didUserRejoinTheGame) {
            setChosenStrengthCard(mappedArryOfStrengthCardsObjectsFittedForFrontend);
            setDidUserRejoinTheGame(false);
        }

    }, [didUserRejoinTheGame, setDidUserRejoinTheGame, userData, game?.gameInfo?.inGameLobby]);

    const numberOfPopulatedCards = useCallback(() => {
        return chosenStrengthCard.filter(card => card !== undefined).length;
    }, [chosenStrengthCard]);

    useEffect(() => {
        if (numberOfPopulatedCards() === 5 && !isConfirmSelectionClicked) {
            return setConfirmSelectionDisabled(false);
        }

        return setConfirmSelectionDisabled(true);
    }, [chosenStrengthCard, setConfirmSelectionDisabled, numberOfPopulatedCards, isConfirmSelectionClicked]);

    const convertRecievedObjectToStrengthCardObject = (strengthCardFromBackEnd: any) => {
        return {
            backImagePath: "",
            description: strengthCardFromBackEnd.description,
            id: strengthCardFromBackEnd._id | 0,
            type: CardType.STRENGTH
        }
    }

    const isCardChoosen = (draggableCard: ICard) => {
        return chosenStrengthCard.filter(card => {
            if (card) return card.id === draggableCard.id
            return false;
        }).length;
    }

    const dropedStrenghtCard = () => {
        if (selectedIndex === null) return;

        if (draggableCard && isStrengthCardCurrentlyDragged) {

            if (isCardChoosen(draggableCard)) {
                activateNotificatoinForTwoSeconds();
                return;
            }

            if (numberOfPopulatedCards() < 5) {
                const copyOfChoosen: ICard[] = [];
                const choosenCards = Object.assign(copyOfChoosen, chosenStrengthCard)

                if (choosenCards[selectedIndex]) return;

                choosenCards[selectedIndex] = draggableCard;

                setChosenStrengthCard(choosenCards);
                socket?.emit("chooseStrengthCardNewPlayer", { id: draggableCard.id, idsOfCardsInSlotMachine: allStrengthCardsIdsState.current });
                setAddStrengthCardDemo({id: draggableCard?.id || 1111, description: draggableCard?.description || ""});

                verticalCardIndexOfSelectedRow.current = verticalCardIdsAndTheirIndexes?.find((card: any) => draggableCard.id === card.cardId)?.verticalIndex;
                setLastDroppedCard(draggableCard);
            }
        }
        setIsStrengthCardCurrentlyDragged(false);
    }

    const activateNotificatoinForTwoSeconds = () => {
        setShowIt(true);

        if (alertRef.current) {
            clearTimeout(alertRef.current);
        }

        alertRef.current = setTimeout(() => {
            setShowIt(false);
        }, 3000)
    }

    const removeChosenCard = (cardId: number | string, index: number) => {
        const copyOfChoosen: (ICard | undefined)[] = [];
        const choosenCards = Object.assign(copyOfChoosen, chosenStrengthCard)

        setSelectedIndex(null);
        choosenCards[index] = undefined;
        setChosenStrengthCard(choosenCards);
        socket?.emit("dropStrengthCard", { id: cardId });
        playSound("/sounds/CloseCard.mp3");

        return setConfirmSelectionDisabled(true);
    }

    const draggedStrengthCardsFields = (index: number) => {
        return (
            <div onMouseEnter={() => setSelectedIndex(index)} onMouseLeave={() => setSelectedIndex(null)} className="drop_container__content center_horizontally_and_vertically" style={{ minHeight: width * 0.155, minWidth: width * 0.118 }}>
                {(chosenStrengthCard[index] && !isConfirmSelectionClicked) && <div className="slot_machine_lower_part_clear_x" onClick={() => removeChosenCard(chosenStrengthCard[index]!.id!, index)}> </div>}
                {chosenStrengthCard[index] && <FrontSide cardData={chosenStrengthCard[index] || demoCard} />}
            </div>
        )
    }

    const SlotMachineChosenCards = () => {
        return Array.apply(null, Array(5)).map((_item: any, index: number) => {
            return (
                <div key={index} style={{ marginRight: "5%" }}>
                    <div style={{ position: "relative" }}> <div className="drop_containter_parent" style={{ minHeight: width * 0.156, minWidth: width * 0.12 }} ></div> </div>
                    <div className="slot_machine_placeholder_border">
                        {draggedStrengthCardsFields(index)}
                    </div>
                </div>
            )
        })
    }

    const handlyReady = () => {
        setReady(true);
        setShowMidGameWaitingWindow(true);
    }

    const renderButton = () => {
        if (isPageSlotMachineDemoRendered) return <MainButton type="big" text={confirmText} clickHandler={handlyReady} disabled={confirmSelectionDisabled || ready} />;
        return <PdfIndex pdfType="strengthsDemo" selectedStrengthsDemo={[chosenStrengthCard[0]?.description || "", chosenStrengthCard[1]?.description || "", chosenStrengthCard[2]?.description || "", chosenStrengthCard[3]?.description || "", chosenStrengthCard[4]?.description || "" ]}/>
    }

    return (
        <div className="slot_machine_lower_part_wrapper" >
            <div className="slot_machine_lower_horizontal_line">
                <div className="linear_gradient_line_horizontal"> </div>
            </div>

            <div style={{ width: "100%" }}>
                <div className="drop_container">
                    {SlotMachineChosenCards()}
                </div>
            </div>

            {!confirmSelectionDisabled && isArrowShown &&
                <div className="white_arrow_confirm_button_in_slot_machine_wrapper">
                    <img className="white_arrow_in_slot_machine" src={whiteArrow} alt="white arrow" />
                </div>
            }

            <div style={{ marginTop: width * 0.02, width: '20%' }} className="slot_machine__confirm_button" onClick={() => setIsArrowShown(false)}>
                {renderButton()}
            </div>
        
            
        </div>
    );
});

export default SlotMachineChosenCardHolder;